import httpClient from '@/services/http/httpClient'
import * as Blobs from '@/infra/blobs'

export const apiGetAdminDamagesReparationsTypes = () => {
    return httpClient.get('admin/damages/reparations/types')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesWarrantyTypes = () => {
    return httpClient.get('admin/damages/warranties/types')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesWarrantySubtypes = warrantyId => {
    const params = {}
    if (warrantyId) params.warranty_id = warrantyId

    return httpClient.get('admin/damages/warranties/subtypes', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesDamagetypes = () => {
    return httpClient.get('admin/damages/damagetypes/')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesParameters = (page = 1) => {
    return httpClient.get(`admin/damages/parameters/?page=${page}`)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminDamagesParameters = (paramName, paramValue, customizable) => {
    return httpClient.post('admin/damages/parameters/', {
            param_name: paramName,
            param_value: paramValue,
            customizable
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesReparations = (page = 1, warrantyId, subwarrantyId) => {
    let params = { page }

    if (warrantyId) params['warranty_id'] = warrantyId
    if (subwarrantyId) params['warranty_subtype_id'] = subwarrantyId

    return httpClient.get('admin/damages/reparations/', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminDamagesReparations = (
    damagesType,
    description,
    repTypeCode,
    surfaceUnit,
    priceCalcForm,
    type
) => {
    return httpClient.post('admin/damages/reparations/', {
            damages_type: damagesType,
            description,
            rep_type_code: repTypeCode,
            surface_unit: surfaceUnit,
            price_calc_form: priceCalcForm,
            type
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesCoefficients = (page = 1, warrantyId, subwarrantyId) => {
    let params = { page }

    if (warrantyId) params['warranty_id'] = warrantyId
    if (subwarrantyId) params['warranty_subtype_id'] = subwarrantyId

    return httpClient.get('admin/damages/coeficients/', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminDamagesCoefficients = (
    repCodeType,
    description,
    coefMat,
    coefMo,
    matSRen,
    price
) => {
    return httpClient.post('admin/damages/coeficients/', {
            rep_code_type: repCodeType,
            description,
            coef_mat: coefMat,
            coef_mo: coefMo,
            mat_s_ren: matSRen,
            price
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesDepreciations = (page = 1, warrantyId, subwarrantyId) => {
    let params = { page }

    if (warrantyId) params['warranty_id'] = warrantyId
    if (subwarrantyId) params['warranty_subtype_id'] = subwarrantyId

    return httpClient.get('admin/damages/depreciations/', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminDamagesDepreciations = (
    repTypeCode,
    description,
    years,
    depreciationPerc
) => {
    return httpClient.post('admin/damages/depreciations/', {
            rep_type_code: repTypeCode,
            description,
            years,
            depreciation_perc: depreciationPerc
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesTransversalscosts = (page = 1, warrantyId, subwarrantyId) => {
    let params = { page }

    if (warrantyId) params['warranty_id'] = warrantyId
    if (subwarrantyId) params['warranty_subtype_id'] = subwarrantyId

    return httpClient.get('admin/damages/transversalcosts/', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminDamagesTransversalscosts = (
    componentName,
    costFormat,
    damageType,
    description,
    value
) => {
    return httpClient.post('admin/damages/transversalcosts/', {
            component_name: componentName,
            cost_format: costFormat,
            damage_type: damageType,
            description,
            value
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// TEMPLATES
export const getAdminDamagesTemplates = (
    tabId,
    warrantyId,
    warrantySubtypeId
) => {
    return httpClient.get('admin/damages/templates', {
            responseType: 'arraybuffer',
            params: {
                tab_id: tabId,
                warranty_id: warrantyId,
                warranty_subtype_id: warrantySubtypeId
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const postAdminDamagesTemplates = file => {
    const formData = new FormData()
    formData.append('file', file)
    return httpClient.post('admin/damages/templates', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminDamagesSurfaceUnits = () => {
    return httpClient.get('admin/damages/surfaceunits/')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminUserCompanies = (companyId) => {
    return httpClient.get('/admin/users/companies?=')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminUserRoles = (companyId) => {
    return httpClient.get(`admin/users/roles/${companyId}/`)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminUserList = (companyId, page = 1) => {
    const params = { page }

    if (companyId) params['company_id'] = companyId

    return httpClient.get('/admin/users/', { params })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPostAdminUser = (firstName, lastName, username, email, company, role) => {
    return httpClient.post('/admin/users/', {
            first_name: firstName,
            last_name: lastName,
            username: username,
            email: email,
            company: company,
            role: role
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminUser = (firstName, lastName, username, email, company, role) => {
    const params = {
        first_name: firstName,
        last_name: lastName,
        username: username,
        email: email,
        company: company,
        role: role
    }
    return httpClient.post('/admin/users/update', params)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPostAdminUserDelete = username => {
    const params = {}
    if (username) params.username = username

    return httpClient.post('/admin/users/delete', { data: { username } })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetFormFilters = () => httpClient.get('/forms/types/')

export const apiGetFormProcessStatus = () => httpClient.get('/forms/files/status/')

export const apiGetFormFile = ({ id }) => httpClient.get(`/forms/export-async/${id}/`)

export const apiDownloadFormFile = (url) => httpClient.get(url, {
    responseType: 'blob'
}).then((blobResponse) => {
    const fileName = url.split('/').find(Blobs.fileExtensions.isExcel)
    Blobs.blobToFile(fileName, blobResponse, Blobs.mimeTypes.EXCEL)
})

export const apiPostFormFile = ({ id, blob }) => httpClient.post('/forms/import-async/', { id, blob })